import { createFileRoute } from "@tanstack/react-router";
import ProductHubList from "@/pages/ProductHubList";

export const Route = createFileRoute("/pressure-washers/buying-guides")({
  component: () => <ProductHubList hubSlug="pressure-washers" variant="buying-guides" />,
});
